import { fileUrl } from '../api/client';

const TONE = { veg: 'var(--success)', non_veg: 'var(--danger)', egg: '#D97706' };

/** The veg / non-veg square every Indian menu carries. */
export const VegMark = ({ type = 'veg' }) => (
  <span className="veg-mark" style={{ borderColor: TONE[type] || TONE.veg }}>
    <span style={{ background: TONE[type] || TONE.veg }} />
  </span>
);

/**
 * One dish on a restaurant's menu: mark, name, price (from the cheapest size
 * when there are sizes), what can be customised, the picture with ADD on it.
 */
const MenuItemCard = ({
  item, inCart = 0, canOrder, onAdd, onClick,
  /** Two to a row, as in a shop's aisle: picture on top, details under it. */
  compact = false,
}) => {
  const sizes = item.variants || [];
  const groups = item.addonGroups || [];
  const from = sizes.length ? Math.min(...sizes.map((v) => v.price)) : item.price;
  const customisable = sizes.length > 0 || groups.length > 0;

  if (compact) {
    return (
      <div className="card sh-sm menu-tile" role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}>
        <div className="menu-tile-top">
          {item.images && item.images[0] ? (
            <img src={fileUrl(item.images[0])} alt={item.title} />
          ) : (
            <div className="menu-tile-fallback">🍽️</div>
          )}
          {canOrder ? (
            <button
              type="button"
              className={`add-btn ${inCart > 0 ? 'on' : ''}`}
              disabled={!item.inStock}
              onClick={(e) => { e.stopPropagation(); onAdd(); }}
            >
              {!item.inStock ? 'SOLD OUT' : inCart > 0 ? `${inCart} ADDED` : 'ADD'}
            </button>
          ) : null}
        </div>
        <div className="menu-tile-body">
          <div className="row" style={{ gap: 6, alignItems: 'center' }}>
            <VegMark type={item.foodType || (item.isVeg ? 'veg' : 'non_veg')} />
            {item.isPopular ? <span style={{ fontSize: 11, color: '#D97706', fontWeight: 800 }}>★</span> : null}
          </div>
          <div className="t-body clamp-2" style={{ fontWeight: 700, marginTop: 4 }}>{item.title}</div>
          <div className="t-body" style={{ fontWeight: 800 }}>
            {sizes.length ? 'from ' : ''}₹{from}
            {item.mrp > item.price && !sizes.length ? <span className="t-tiny" style={{ textDecoration: 'line-through', marginLeft: 6 }}>₹{item.mrp}</span> : null}
          </div>
          {customisable ? <div className="t-tiny" style={{ color: 'var(--primary)' }}>customisable</div> : null}
        </div>
      </div>
    );
  }

  return (
    <div className="card sh-sm menu-item" role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }} style={{ cursor: 'pointer' }}>
      <div className="grow" style={{ minWidth: 0 }}>
        <div className="row" style={{ gap: 8, alignItems: 'center' }}>
          <VegMark type={item.foodType || (item.isVeg ? 'veg' : 'non_veg')} />
          {item.isPopular ? <span style={{ fontSize: 11, color: '#D97706', fontWeight: 800 }}>★ Bestseller</span> : null}
        </div>
        <div className="t-title" style={{ marginTop: 4 }}>{item.title}</div>
        <div className="t-body" style={{ fontWeight: 800 }}>
          {sizes.length ? 'from ' : ''}₹{from}
          {item.mrp > item.price && !sizes.length ? <span className="t-tiny" style={{ textDecoration: 'line-through', marginLeft: 6 }}>₹{item.mrp}</span> : null}
        </div>
        {item.description ? <div className="t-tiny clamp-2">{item.description}</div> : null}
        {customisable ? (
          <div className="t-tiny" style={{ color: 'var(--primary)', marginTop: 4 }}>
            {[sizes.length ? sizes.map((v) => v.label).join(' / ') : '', ...groups.map((g) => g.title)].filter(Boolean).join(' · ')}
          </div>
        ) : null}
      </div>
      <div style={{ display: 'grid', justifyItems: 'center' }}>
        {item.images && item.images[0] ? (
          <img className="photo" src={fileUrl(item.images[0])} alt={item.title} />
        ) : (
          <div className="photo" style={{ display: 'grid', placeItems: 'center', fontSize: 28 }}>🍽️</div>
        )}
        {canOrder ? (
          <button
            type="button"
            className={`add-btn ${inCart > 0 ? 'on' : ''}`}
            disabled={!item.inStock}
            onClick={(e) => { e.stopPropagation(); onAdd(); }}
          >
            {!item.inStock ? 'SOLD OUT' : inCart > 0 ? `${inCart} ADDED` : 'ADD'}
            {customisable && item.inStock ? <span className="add-hint">customisable</span> : null}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default MenuItemCard;
